
let  button =  {
    add: 'Add',
    del: 'Delete',
    confirm: 'Confirm',
    cancle: 'Cancel',
    yes: 'Yes',
    no: 'No',
    positionReport: 'Position Report',
    tradingHistory: 'Trading History',
    startDate: 'Start Date',
    to: 'To',
    endDate: 'End Date',
    latelyWeek: 'Lately Week',
    latelyMonth: 'Lately Month',
    latelyThreeMonth: 'Lately Three Month',
    auth: ' Privilege Assignment',
    edit: 'Modily',
    disabled: 'Disabled',
    undisabled: 'Allow',
    affirm: 'Affirm',
    refuse: 'Refuse'

}

export default button;




















































// WEBPACK FOOTER //
// ./src/i18n/english/button.js